// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class I32 implements flatbuffers.IUnpackableObject<I32T> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): I32 {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsI32(bb: flatbuffers.ByteBuffer, obj?: I32): I32 {
    return (obj || new I32()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsI32(bb: flatbuffers.ByteBuffer, obj?: I32): I32 {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new I32()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  static startI32(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt32(0, value, 0);
  }

  static endI32(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createI32(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    I32.startI32(builder);
    I32.addValue(builder, value);
    return I32.endI32(builder);
  }

  unpack(): I32T {
    return new I32T(this.value());
  }

  unpackTo(_o: I32T): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): I32T {
    const t = new I32T();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class I32T implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return I32.createI32(builder, this.value);
  }

  clone(): I32T {
    const obj = new I32T();
    obj.value = this.value;
    return obj;
  }

  equals(other: I32T): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyI32(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
  } finally {
    verifier.popDepth();
  }
}
